export const ACTIVE_ONBOARDING_STATUSES = new Set([
  "import_failed",
  "split_preview",
  "in_progress",
]);

const COMPLETED_ONBOARDING_STATUSES = new Set([
  "completed",
  "skipped",
  "creative",
]);

export const shouldShowProjectOnboarding = ({ state, scripts, episodes }) => {
  const status = String(state?.status || "");
  if (COMPLETED_ONBOARDING_STATUSES.has(status)) return false;

  // Episodes are the durable boundary between setup and production. Once a
  // project has entered episode production, a stale/failed onboarding task
  // must stay recoverable from the script center without taking over entry.
  if (!Array.isArray(episodes)) return false;
  if (episodes.length > 0) return false;

  if (ACTIVE_ONBOARDING_STATUSES.has(status)) return true;
  if (!Array.isArray(scripts)) return false;
  return scripts.length === 0;
};
